export default __webpack_public_path__ + "static/media/schar_certificate.66905ddf.png";